import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import $ from "jquery";
import { createHead } from "@vueuse/head";

// CSS Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// JS Bootstrap
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "bootstrap-icons/font/bootstrap-icons.css";

import { createI18n } from "vue-i18n";

import FR from "./locale/fr.json";
import EN from "./locale/en.json";
import NL from "./locale/nl.json";
import DE from "./locale/de.json";
import ES from "./locale/es.json";

import "./app.scss";

// Détection de la langue du navigateur
const browserLang = navigator.language.split("-")[0].toLowerCase(); // exemple : 'fr-BE' → 'fr'
const langMap = { fr: "FR", en: "EN", nl: "NL", de: "DE", es: "ES" };
const defaultLocale = "FR";

// On convertit la langue navigateur en une clé compatible
const detectedLocale = langMap[browserLang] || defaultLocale;

const app = createApp(App);

const i18n = createI18n({
  legacy: false,
  locale: detectedLocale,
  fallbackLocale: "FR",
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    FR,
    EN,
    NL,
    DE,
    ES,
  },
});

const head = createHead();

// Ajoutez jQuery globalement
app.config.globalProperties.$ = $;

app.use(head);
app.use(i18n);
app.use(store);
app.use(router);

app.mount("#app");

if (typeof document !== "undefined") {
  document.dispatchEvent(new Event("render-event"));
}
